export const stylingFunctions = {
    ALIGN: (_alignment, value) => value,
    SPACES: (value) => '&nbsp;'.repeat(Number(value)),
    STRIKE: (value) => `<span style="text-decoration: line-through" class="wixui-rich-text__text">${value}</span>`,
    UNDERLINE: (value) => `<span style="text-decoration: underline" class="wixui-rich-text__text">${value}</span>`,
    ITALIC: (value) => `<span style="font-style: italic" class="wixui-rich-text__text">${value}</span>`,
    BOLD: (value) => `<span style="font-weight: bold" class="wixui-rich-text__text">${value}</span>`,
    HIGHLIGHT: (color, value) => `<span style="background-color: ${color}" class="wixui-rich-text__text">${value}</span>`,
    COLOR: (color, value) => `<span style="color: ${color}" class="wixui-rich-text__text">${value}</span>`,
};
//# sourceMappingURL=stylingFunctions.js.map